module.exports = __webpack_public_path__ + "static/media/5.bb320130.jpg";